<template>
  <div>
    <p>不好，404啦！</p>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style lang="scss" scoped></style>
